module.exports = __webpack_public_path__ + "static/media/loading.3fa5073c.gif";